import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { trackPageView } from "@/lib/analytics/track";

export function usePageView(): void {
  const location = useLocation();
  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    // React 19 + StrictMode can double-invoke effects in dev; guard against duplicates.
    if (lastPathRef.current === location.pathname) return;
    lastPathRef.current = location.pathname;
    trackPageView(location.pathname);
  }, [location.pathname]);
}
